/* global google */
import { forEach } from './foreach'
import { reduce } from './reduce'

export const applyUpdaterToNextProps = (
  updaterMap,
  prevProps,
  nextProps,
  instance
) => {
  const map = {}

  const iter = (fn, key) => {
    const nextValue = nextProps[key]

    if (nextValue !== prevProps[key]) {
      map[key] = nextValue
      fn(instance, nextValue)
    }
  }

  forEach(updaterMap, iter)

  return map
}

export function registerEvents(
  props,
  instance,
  eventMap
) {
  const registeredList = reduce(
    eventMap,
    function reducer(
      acc,
      googleEventName,
      onEventName
    ) {
      if (typeof props[onEventName] === 'function') {
        acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]))
      }

      return acc
    },
    []
  )

  return registeredList
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}

export function unregisterEvents(events) {
  events.forEach(unregisterEvent)
}

export function applyUpdatersToPropsAndRegisterEvents({
  updaterMap,
  eventMap,
  prevProps,
  nextProps,
  instance
}) {
  const registeredEvents = registerEvents(nextProps, instance, eventMap)
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance)
  return registeredEvents
}
